import aggregateLearningLeaderboard from "./aggregateLearningLeaderboard.json";
import common from "./common.json";
import dashboardWidgets from "./dashboardWidgets.json";
import programDashboard from "./programDashboard.json";
import programs from "./programs.json";

export default {
  aggregateLearningLeaderboard,
  common,
  dashboardWidgets,
  programDashboard,
  programs,
};
